<template>
  <div>
    <Head title="Create Airline" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item"><Link href="/settings/operators">Operators</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Create Operators</li>
      </ol>
    </nav>
    <h1>Create Operator</h1>

    <div class="content-box">
      <form @submit.prevent="store">
        <OperatorForm :form="form" :types="types" />

        <div class="actions-toolbar">
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Create Operator</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import OperatorForm from './components/OperatorForm'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    OperatorForm,
    LoadingButton,
  },
  props: ['types'],
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        code: null,
        contact_name: null,
        contact_email: null,
        contact_phone: null,
        comment: null,
        types: []
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/settings/operators')
    },
  },
}
</script>
